export { default } from "./DetailHero";
export * from "./DetailHero";
